import React from 'react';
import CompleteSimulationProvider from '@contexts/scenarios-simulator/complete-simulation';
import MakeSimulationProvider from '@contexts/scenarios-simulator/make-simulation';
import OptimizedScenarioProvider from '@contexts/scenarios-simulator/optimized-scenario';
import ConvertedConsumptionHistoryProvider from '@contexts/scenarios-simulator/converted-consumption-history';
import EnergyPricesProvider from '@contexts/scenarios-simulator/energy-prices';
import LeadProposalsIndexerProvider from '@contexts/lead-proposals-indexer';
import { composeProviders } from '@utils/compose-providers';

interface ScenariosSimulatorProvidersProps {
  children: React.ReactNode;
}

const ComposedProviders = composeProviders(
  LeadProposalsIndexerProvider,
  CompleteSimulationProvider,
  MakeSimulationProvider,
  OptimizedScenarioProvider,
  ConvertedConsumptionHistoryProvider,
  EnergyPricesProvider,
);

export function ScenariosSimulatorProviders({ children }: ScenariosSimulatorProvidersProps) {
  return <ComposedProviders>{children}</ComposedProviders>;
}
